var map = {
	"./AbdulkhaliqYa3qubi.jpg": "2648",
	"./AbdulqadirSaed.jpg": "39c7",
	"./AramHasan.jpg": "e63f",
	"./AramKakayFalah.jpg": "a0ae",
	"./AramMohamad.jpg": "0476",
	"./AtaMuhammad.jpg": "630f",
	"./AzadBarzinji.jpg": "6ce4",
	"./AzadGulladin.jpg": "9343",
	"./DiaryBarham.jpg": "65bf",
	"./DlawarQaradaghy.jpg": "46a2",
	"./DlshadRawand.jpg": "f34d",
	"./DrMuhsin.jpg": "2a1d",
	"./HalimYusuf.jpg": "c938",
	"./HavalKwestani.jpg": "39dd",
	"./HershOmer.jpg": "bf2f",
	"./HiwaQader.jpg": "2c4b",
	"./IdrisAli.jpg": "b40c",
	"./JabarJamal.jpg": "05d9",
	"./JalilKakaWais.jpg": "80f4",
	"./KamaranSubhan.jpg": "1a0f",
	"./KarimKaka.jpg": "0dc5",
	"./KatanXadimi.jpg": "68ef",
	"./KhalilAbdula.jpg": "c80c",
	"./KurdoShaban.jpg": "ec39",
	"./MihmedTahir.jpg": "67dc",
	"./MuhammadHamo.jpg": "0f6d",
	"./NarminOsman.jpg": "66a2",
	"./NazaninOsman.jpg": "3069",
	"./PayamIbrahim.jpg": "a639",
	"./RawaZaydan.jpg": "deeb",
	"./Roza.jpg": "ff58",
	"./RozaShekhani.jpg": "61b9",
	"./SamanKhanaqini.jpg": "437f",
	"./SeidViroj.jpg": "6b3d",
	"./ShafiqiHaji.jpg": "1533",
	"./YasinArif.jpg": "6820"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f400";